import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ShareableLinkSpaceAdminControlsLoader } from '@confluence/access-links/entry-points/ShareableLinkSpaceAdminControlsLoader.ts';

export const ShareableLinkSpaceSettingsRoute: {
	({ params: { spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(
		{ name, params: { spaceKey } }: RouteMatch,
		isNav4Enabled: any,
	): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
			};
			pageState: {
				routeName: string;
				spaceKey: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
		};
	};
} = ({ params: { spaceKey } }: RouteMatch): React.JSX.Element => {
	return <ShareableLinkSpaceAdminControlsLoader spaceKey={spaceKey} />;
};

ShareableLinkSpaceSettingsRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } }: RouteMatch,
	isNav4Enabled: any,
): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
		};
		pageState: {
			routeName: string;
			spaceKey: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'spaceSettingsAccessLinksScreen',
			id: spaceKey,
		},
		pageState: {
			routeName: name,
			spaceKey,
		},
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
	},
});
